import { defineStore } from 'pinia'

export const audioStore = defineStore({
  id: 'audio',
  state: () => ({
    allowAudio: JSON.parse(localStorage.getItem('allowAudio')) || false, // Load initial state from localStorage
    audioContext: null,
    audioBuffer: null
  }),
  actions: {
    async initializeAudio() {
      if (!this.audioContext) {
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
        console.log('Global AudioContext initialized')
      }

      if (!this.audioBuffer) {
        try {
          const response = await fetch('https://opusbroker.blob.core.windows.net/images/chaching.mp3')
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
          const arrayBuffer = await response.arrayBuffer()
          this.audioBuffer = await this.audioContext.decodeAudioData(arrayBuffer)
          console.log('Global audio file loaded and decoded successfully')
        } catch (error) {
          console.error('Error loading global audio file:', error)
        }
      }
    },
    async playSound() {
      if (this.audioBuffer === null || this.audioContext === null) {
        await this.initializeAudio()
      }
      if (this.audioBuffer && this.audioContext) {
        const source = this.audioContext.createBufferSource()
        source.buffer = this.audioBuffer
        source.connect(this.audioContext.destination)
        source.start(0)
        console.log('Sound played globally')
      } else {
        console.error('AudioContext or AudioBuffer not initialized')
      }
    },
    toggleAllowAudio(status) {
      this.allowAudio = status
      localStorage.setItem('allowAudio', JSON.stringify(status)) // Save to localStorage
      if (!status && this.audioContext) {
        this.audioContext.close()
        this.audioContext = null
        console.log('AudioContext disabled')
      } else if (status) {
        this.initializeAudio()
      }
    }
  }
})
